import { createStore } from "vuex";
import getters from "./getters";
import usuarios from "./modules/usuarios";
import navegacion from "./modules/navegacion";

export default createStore({
  getters,
  modules: {
    navegacion,
    usuarios
  }
});
